import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MemberService } from '../../../services';
import { AlertService } from '../../../services/alert.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-send-email-form',
  templateUrl: './send-email-form.component.html',
  styleUrls: ['./send-email-form.component.css']
})
export class SendEmailFormComponent implements OnInit {

  @Input() usersList = [];
  @Output() closed: EventEmitter<boolean> = new EventEmitter();
  form: FormGroup;

  Editor = ClassicEditor;

  constructor(
    private fb: FormBuilder,
    private memberService: MemberService,
    private alertService: AlertService
  ) {
    this.form = this.fb.group({
      subject: [null, Validators.required],
      message: [null, Validators.required]
    });
  }

  ngOnInit() {
  }

  onSubmit(event: Event) {
    event.preventDefault();
    this.form.disable();

    const clubId = +localStorage.getItem('clubId');

    this.memberService.sendEmailToPlayers({
      userIDs: this.usersList,
      ...this.form.value,
      sendToParents: true,
      sendToPlayers: false
    }, clubId).subscribe(
      () => {
        this.alertService.success('HIGH FIVE! your emails were sent successfully.');
        this.closed.emit(true);
        this.resetForm();
      },
      () => {
        this.alertService.error('WE HAVE A PROBLEM! Emails were not sent.');
        this.form.enable();
      }
    );
  }

  onClose(event: Event) {
    event.preventDefault();
    this.closed.emit(false);
    this.resetForm();
  }

  resetForm() {
    this.form.enable();
    this.form.patchValue({
      messageText: null,
      messageBody: null
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/send-email-form/send-email-form.component.ts